export default {
    url: '/settings',
    template: '<user-competence-settings company="vm.company"/>',
    resolve: {
        company: (CompanyResource, TokenService) => CompanyResource.get({ id: TokenService.getCompanyId() }).$promise
    },
    controller (company) {
        this.company = company;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/competence/settings/index.js